exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/_object-gops.js
// module id = Y1N3
// module chunks = 0